"use client";

import { ReactNode } from "react";
import IconPlus from "@/app/(components)/generics/Icons/IconPlus";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { MessageSequenceStepVariantData } from "@/app/types/messages-content/MessageSequenceData";
import { UStyles } from "@/app/utils/UStyles";
import { variantLetter, variantName } from "./MessageSequence.logic";
import styles from "./MessageSequence.module.css";

type Props = {
  variants: MessageSequenceStepVariantData[];
  currentId: number;
  canAdd?: boolean;
  actions?: ReactNode;
  onSelect: (variantId: number) => void;
  onAdd?: () => void;
};

export default function SequenceVariantTabs(props: Props) {
  const T = useT();
  const { variants, currentId, canAdd = false, actions, onSelect, onAdd } = props;

  return (
    <div className={styles.variantTabs}>
      {variants.map((variant, index) => (
        <button
          key={variant.id}
          type="button"
          className={UStyles.classNames(
            styles.variantTab,
            variant.id === currentId ? styles.variantTabActive : "",
          )}
          onClick={() => onSelect(variant.id)}
        >
          <span className={styles.variantTabShort}>{variantLetter(index)}</span>
          <span className={styles.variantTabFull}>{variantName(variant, index, T)}</span>
        </button>
      ))}

      {canAdd && onAdd && (
        <button
          type="button"
          className={styles.variantTabAdd}
          onClick={onAdd}
          aria-label={T(TKey.MESSAGES_CONTENT_ADD_VARIANT) as string}
        >
          <IconPlus />
        </button>
      )}

      {actions && <div className={styles.stepActions}>{actions}</div>}
    </div>
  );
}
